/* eslint-disable @typescript-eslint/no-explicit-any */
import { ExtensionType } from "../../../store/types/Extension";
import { makeStyles } from "@material-ui/core";
import {TFunction} from 'react-i18next';
import { YesNo } from "../../../store/types/CallScreening";
import { BillStatus } from "../../../store/types/SipTrunk";
import { Colors } from "../../../styles/Colors";
import { DefaultAnsweringActionFlag } from "../../../store/types/ServiceFeature";

export type ForwardingModeDropdownProps = {
    account: ExtensionType,
    onChange?: (value: DefaultAnsweringActionFlag) => void,
};

export const styles = {
    control: (base: any, state: any) => ({
        ...base,
        minHeight: '56px',
        borderColor: state.selectProps.menuIsOpen ? 'rgba(221, 225, 231, 1)' : 'white',
        '&:hover': {
            borderColor: 'rgba(221, 225, 231, 1)',
        },
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        borderBottomLeftRadius: state.selectProps.menuIsOpen ? 0 : 8,
        borderBottomRightRadius: state.selectProps.menuIsOpen ? 0 : 8,
        borderBottom: state.selectProps.menuIsOpen ? '1px solid transparent' : '1px solid #rgba(221, 225, 231, 1)',
        backgroundImage: state.selectProps.menuIsOpen 
            ? 'linear-gradient(to right,  transparent 0%, rgba(221, 225, 231, 1) 42px, rgba(221, 225, 231, 1) calc(100% - 42px), transparent 100%)'
            : 'none',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom',
        backgroundSize: '100% 1px',
        boxShadow: state.selectProps.menuIsOpen ? '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' : 'none',
    }),
    valueContainer: (base: any) => ({
        ...base,
        alignItems: 'flex-start',
        paddingTop: 6,
        paddingBottom: 6,
    }),
    singleValue: (base: any) => ({
        ...base,
        position: 'relative',
        transform: 'none',
        whiteSpace: 'normal',
    }),
    option: (base: any, state: any) => ({
        ...base,
        backgroundColor: state.isSelected
            ? '#d9d9d9'
            : state.isFocused
                ? '#f5f5f5'
                : 'white',
        color: '#333',
        fontWeight: state.isSelected ? 'bold' : 'normal',
        cursor: 'pointer',
        ':active': {
            backgroundColor: state.isSelected ? '#d9d9d9' : '#f5f5f5',
        },
    }),
    menu: (base: any) => ({
        ...base,
        marginTop: 0,
        border: '1px solid #ccc',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        borderTop: 'none',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    }),
    menuList: (base: any) => ({
        ...base,
        padding: 0,
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 99 })
};

export const useStyles = makeStyles(() => ({
    customOptionContainer: { 
        display: 'flex',
        alignItems: 'flex-start',
        fontSize: 14,
        color: Colors.Text,
    },
    choosenValueContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    choosenValueTopContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: 8,
    },
    accountStatusLabel: {
        justifySelf: 'start',
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '28px',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
    },
    accountStatusLabelActive: {
        color: 'rgba(117, 185, 67, 1)'
    },
    accountStatusLabelInactive: {
        color: 'rgba(245, 132, 31, 1)'
    },
    accountNameLabel: {
        justifySelf: 'end',
        fontWeight: 400,
        fontSize: 12,
        lineHeight: '28px',
        verticalAlign: 'middle',
        color: Colors.Gray,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    choosenValue: {
        gridColumn: '1 / -1',
        color: Colors.Text3,
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '20px',
        verticalAlign: 'middle',
    },
    dropdownIndicator: {
        display: 'inline-block',
        transition: 'transform 0.2s',
        color: 'rgba(136, 136, 136, 1)'
    },
    customGroupHeader: {
        textTransform: 'none',
        fontSize: 13,
        fontWeight: 400,
        color: Colors.Gray,
    }
}));

export const getSipStatusLabelValue = (account: ExtensionType | undefined, t: TFunction<string>) => {
    if(!account) return '';
    if(account.blocked == YesNo.Yes) return t('screens:extensions.disabled');
    if(account.bill_status == BillStatus.Inactive) return t('screens:sipTrunks.inactive');
    if(account.sip_status == 1) return t('screens:extensions.sipStatusRegister');
    if(account.sip_status == 0) return t('screens:extensions.sipStatusUnregister');
    return '';
}